import { isNil } from 'lodash-es';
import { Destination } from './destination';
import { MappedArea } from './mapped-area';
import { Order } from './order';
import { Product } from './product';
import { ProductCondition } from './product-condition';
import { ProductConditionRequest, ProductConditionResponseAttributes } from './product-condition-request';



export interface BookingRequestDetailsAttributes {
  availability_ids: string[];
  inventory_unit_ids: number[];
  destination_id?: number;
  mapped_area_id?: number;
  product_id?: number;
  quantity?: number;
  product_conditions?: ProductConditionResponseAttributes[];
}

export interface BookingRequestAttributes {
  booking: BookingRequestDetailsAttributes;
  order_token: string;
}



export class BookingRequest {
  public order: Order;

  private availabilitiesIds: string[];
  private inventoryUnitIds: number[];
  private quantity: number | null;
  private productConditionsRequest: ProductConditionRequest;
  private mappedArea?: MappedArea;
  private destination?: Destination;
  private product?: Product;

  constructor(requestDetails: {
    availabilitiesIds: string[];
    inventoryUnitIds: number[] | null;
    mappedArea?: MappedArea;
    destination?: Destination;
    product?: Product;
    quantity?: number;
    productConditions?: ProductCondition[];
   }, order: Order) {
    const {
      availabilitiesIds,
      inventoryUnitIds,
      mappedArea,
      destination,
      product,
      quantity,
      productConditions,
    } = requestDetails;

    this.availabilitiesIds = availabilitiesIds;
    this.inventoryUnitIds = inventoryUnitIds ?? [];
    this.mappedArea = mappedArea;
    this.destination = destination;
    this.product = product;
    this.quantity = quantity ?? null;
    this.productConditionsRequest = new ProductConditionRequest(productConditions);

    this.order = order;
  }

  
  public toJSON(): BookingRequestAttributes {
    const booking: BookingRequestDetailsAttributes = {
      availability_ids: this.availabilitiesIds,
      inventory_unit_ids: this.inventoryUnitIds,
    };

    if (!isNil(this.mappedArea)) {
      booking.mapped_area_id = +this.mappedArea.id;
    }

    if (!isNil(this.destination)) {
      booking.destination_id = +this.destination.id;
    }

    if (!isNil(this.product)) {
      booking.product_id = +this.product.id;
    }

    if (!isNil(this.quantity)) {
      booking.quantity = +this.quantity;
    }

    if ((this.productConditionsRequest?.conditions?.length ?? -1) > 0) {
      booking.product_conditions = this.productConditionsRequest.conditions;
    }

    return {
      booking,
      order_token: this.order.token,
    };
  }
  
}
